module.exports = {
  transclude: true,
  bindings: {
    onClickYes: '&',
    onClickNo: '&',
    yesBtnToken: '=',
    noBtnToken: '=',
  },
  template: `
    <div class="yes-no-dialog-container">
      <div class="yes-no-dialog wrapper">
        <div class="text-over-buttons" ng-transclude></div>
        <div class="buttons-container">
          <button class="button confirm" translate="{{ $ctrl.yesBtnToken ? $ctrl.yesBtnToken : 'global.yes' }}" ng-click="$ctrl.onClickYes()"></button>
          <button class="hollow-button cancel" translate="{{ $ctrl.noBtnToken ? $ctrl.noBtnToken : 'global.no' }}" ng-click="$ctrl.onClickNo()"></button>
        </div>
      </div>
    </div>
  `,
};



// WEBPACK FOOTER //
// ./main/components/yes-no-dialog.js